import { useLang } from "@/context/LangContext";

export function LangToggle({ available = true, className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex items-center rounded-full border border-[var(--line)] bg-white p-0.5 text-xs font-semibold ${className}`} role="group" aria-label="Language" data-testid="lang-toggle">
      <button
        onClick={() => setLang("en")} data-testid="lang-en-btn"
        className={`rounded-full px-3 py-1.5 transition-colors ${lang === "en" ? "bg-[var(--chakra)] text-white" : "text-stone-600 hover:text-[var(--chakra)]"}`}
      >
        English
      </button>
      <button
        onClick={() => setLang("hi")} data-testid="lang-hi-btn" title={available ? "हिन्दी में पढ़ें" : "Hindi version not available for this article"}
        className={`rounded-full px-3 py-1.5 font-devanagari text-sm leading-none transition-colors ${lang === "hi" ? "bg-[var(--saffron)] text-white" : "text-stone-600 hover:text-[var(--saffron-deep)]"} ${available ? "" : "opacity-50"}`}
      >
        हिन्दी
      </button>
    </div>
  );
}
